import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { tap } from 'rxjs'
import { CommonService } from 'src/app/services/common/common.service'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_error_action,
  show_success_msg_action,
  show_success_msg_after_updation_action
} from '../action/common/common.action'

@Injectable()
export class CommonEffects {
  constructor(private actions$: Actions, private cs: CommonService) {}

  route_to_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(route_to_action),
        tap(({ routeTo }) => {
          this.cs.routeTo(routeTo)
        })
      )
    },
    { dispatch: false }
  )

  show_error_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_error_action),
        tap(({ error }) => {
          try {
            this.cs.showError(JSON.parse(error?.message)?.error?.message)
          } catch (e) {
            this.cs.showError('Something went wrong')
          }
        })
      )
    },
    { dispatch: false }
  )

  show_display_id_after_created_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_display_id_after_created_action),
        tap(({ moduleName, displayId }) => {
          this.cs.showSuccess(`${moduleName} created successfully with ID - ${displayId}`)
        })
      )
    },
    { dispatch: false }
  )

  show_success_msg_after_updation_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_success_msg_after_updation_action),
        tap(({ moduleName }) => {
          this.cs.showSuccess(`${moduleName} updated successfully`)
        })
      )
    },
    { dispatch: false }
  )

  show_success_msg$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_success_msg_action),
        tap(({ msg }) => {
          this.cs.showSuccess(msg)
        })
      )
    },
    { dispatch: false }
  )
}
